<template>
  <div>

    <validation-observer
      ref="register_form"
      #default="{invalid}"
    >
      <b-form
        class="auth-register-form mt-2"
        @submit.prevent="register"
      >
        <!-- Firstname -->
        <b-form-group>
          <label for="login-name" class="avenir-medium">{{ $t('register.name') }}</label>
          <validation-provider
            #default="{ errors }"
            :name="$t('register.name')"
            :vid="$t('register.name')"
            rules="required"
          >
            <b-form-input
              id="register-username"
              v-model="user.first_name"
              name="register-username"
              :state="errors.length > 0 ? false:null"
              :placeholder="$t('register.name')"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- lastname -->
        <b-form-group>
          <label for="login-lastname" class="avenir-medium">{{ $t('register.lastname') }}</label>
          <validation-provider
            #default="{ errors }"
            :name="$t('register.lastname')"
            :vid="$t('register.lastname')"
            rules="required"
          >
            <b-form-input
              id="register-lastname"
              v-model="user.last_name"
              name="register-lastname"
              :state="errors.length > 0 ? false:null"
              :placeholder="$t('register.lastname')"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- email -->
        <b-form-group>
          <label for="login-email" class="avenir-medium">Email</label>
          <validation-provider
            #default="{ errors }"
          :name="$t('register.email')"
          :vid="$t('register.email')"
          rules="required|email"
          >
            <b-form-input
              id="register-email"
              v-model="user.email"
              name="register-email"
              :state="errors.length > 0 ? false:null"
              :placeholder="$t('register.email')"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- number -->
        <input-tel-brandme 
          class="mb-2"
          :country_dad="country_selected" 
          :number_dad="user.telephone"
          @number="updateTelephone"
        ></input-tel-brandme>

        <b-button
          variant="blue-button"
          class="blue-button"
          block
          type="submit"
          :disabled="invalid || !state_telephone"
        >        
          {{$t('register.create')}} 
        </b-button>
      </b-form>

      <!-- divider -->
      <div class="divider my-2">
        <div class="divider-text">
          {{ $t('login.divider') }} 
        </div>
      </div>
    </validation-observer>

    <login-container :is_invitation_view="true"></login-container>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BForm,
  BButton
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import invitation_service from '@/services/invitation';
import { setPermissions, setuserData } from '@/libs/utils/user'
import abilities from '@/libs/acl/abilities'
import useJwt from '@/auth/jwt/useJwt';
import { getHomeRouteForLoggedInUser } from '@/auth/utils';

const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');

export default {
  name: 'loginRegister',
  components: {
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    InputTelBrandme: () => import('@/views/components/inputs/InputTelBrandme.vue'),
    loginContainer: () => import('@/views/components/login/loginContainer.vue'),
  },

  data() {
    return {
      user: {
        first_name: '',
        last_name: '',
        email: '',
        telephone: '',
      },
      state_telephone: false,
      country_selected: 'MX',
      readAbility: null,
    }
  },
  created() {
  },
  methods: {
    updateTelephone(telephone_data) {
      this.user.telephone = telephone_data.number;
      this.state_telephone = telephone_data.state;
      this.country_selected = telephone_data.country;
    },
    // Register function for invitation link
    register() {
      const { slug, username, network} = this.$route.params;
      const form_data = new FormData();
      form_data.append('first_name', this.user.first_name);
      form_data.append('last_name', this.user.last_name);
      form_data.append('email', this.user.email);
      form_data.append('telephone', this.user.telephone); 
      form_data.append('slug_campaign', slug);
      form_data.append('username', username);
      form_data.append('network', network);

      this.$refs.register_form.validate().then(success => {
        if (success) {

          invitation_service.register(form_data)
            .then((response) => {
              if (response.status >= 400) {
                this.showErrorLogin(response.data.response.code === 'accounts.CreatorAlreadyRegister' ? this.$t('invitation.errorLogin') : response.data.response.message); 
              } else {
                this.setUser(response);
              }
            })
            .catch(error => {
              console.error('Registration error:', error);

            });
          console.log('Registering user:', this.user);
        }
      })
    },
    setUser(data) {
      useJwt.setToken(data.access_token)
      useJwt.setRefreshToken(data.refresh_token)
     
      setPermissions(data.user);
      this.readAbility = abilities.getAbilitie(data.user)
      if (data.user.main_group) location.reload();
      const show_connect_message = data.user.main_group && data.user.main_group.name === 'creator'
      localStorage.setItem('show_connect_message', show_connect_message)

      setuserData(data, this.readAbility)
      this.$ability.update(this.readAbility)
      this.$store.commit('appConfig/UPDATE_IS_VERIFIED', data.user.is_verified)
      this.$router.push(getHomeRouteForLoggedInUser(data.user))
        .then(() => {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title: `${this.$t('login.welcome')}  ${data.user.first_name || data.user.last_name}`,
                icon: 'CoffeeIcon',
                variant: 'success',
                text: this.$t('login.success')
              }
            })
          })
        })
      if (!data.user.main_group) {
        this.$router.push({name: 'auth-roll'}) 
      }
    },
    showErrorLogin(title) {
      loadToastificationContent().then((component) => {
        this.$toast({
          component: component.default,
          position: 'top-right',
          props: {
            title,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          }
        })
      })
    },
  },
};
</script>